<mat-accordion *ngIf="product" class="clean" multi>
  <mat-expansion-panel [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <h6 class="text-uppercase" i18n="@@Common.Description">Description</h6>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <x-markdown-view [source]="product.description"></x-markdown-view>
  </mat-expansion-panel>
  <mat-expansion-panel *ngFor="let attr of product.attributes; trackBy: 'name' | trackBy">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <h6 class="text-uppercase" [innerText]="attr.name"></h6>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <ng-container [ngSwitch]="attr.type">
      <ng-container *ngSwitchCase="'MARKDOWN'">
        <x-markdown-view [source]="attr.value"></x-markdown-view>
      </ng-container>
      <ng-container *ngSwitchDefault>
        {{ attr.value }}
      </ng-container>
    </ng-container>
  </mat-expansion-panel>
</mat-accordion>
